import { styled } from "@/styles/theme"

export const H1 = styled("h1", {
  fontWeight: "$bold",
  fontSize: "$5xl",
  lineHeight: "1.2em",
  letterSpacing: "$0",
})

export const H2 = styled("h2", {
  fontWeight: "$bold",
  fontSize: "$4xl",
  lineHeight: "1.2em",
  letterSpacing: "$1",
})

export const H3 = styled("h3", {
  fontWeight: "$bold",
  fontSize: "$3xl",
  lineHeight: "1.24em",
  letterSpacing: "-0.01em",
})

export const StyledH4 = styled("h4", {
  fontWeight: "$bold",
  fontSize: "$2xl",
  lineHeight: "1.28em",
})

export const H5 = styled("h5", {
  fontWeight: "$bold",
  fontSize: "$xl",
})

export const H6 = styled("h6", {
  fontWeight: "$bold",
  fontSize: "$lg",
  lineHeight: "1.5rem",
  letterSpacing: "0.0075em",
})
